import React from 'react';
import {
  Container, Col, Row, Button,
} from 'react-bootstrap';
import { Switch, Route, withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import Login from 'components/iam/login';
import ModalPopup from 'components/wrapped-component/modal-popup/modal-popup';
import userDataUtil from 'services/user-data-util';
import GeneralUtils from 'GeneralUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronLeft, faChevronRight, } from '@fortawesome/free-solid-svg-icons';
import routes from '../../routes';
import SidebarNav from '../../components/navigational-component/sidebar-nav/SidebarNav';

class Dashboard extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.collapseSidebar = this.collapseSidebar.bind(this);
    localStorage.setItem('isLoggedIn', 'true');

    let sidebarState = false;
    if (localStorage.getItem('isSidebarNavExpanded') === null || localStorage.getItem('isSidebarNavExpanded') === 'true') {
      sidebarState = true;
    }
    this.state = { sidebarOpen: sidebarState };
  }

  componentDidMount() {
    userDataUtil.initializeUserStats();
    // let dataPointLimitPreference: any;
    // if (localStorage.getItem('SCW_DATA_POINT_LIMIT') === null) {
    //   httpPreference.getPreferenceByName('DEFAULT_SCW_DATA_POINT_LIMIT').then((data) => {
    //     dataPointLimitPreference = JSON.parse(data.value);
    //     if (!dataPointLimitPreference || (dataPointLimitPreference && data.name !== 'WORKFLOW_ENGINE_ITERATION_SLEEP_TIME')) {
    //       localStorage.setItem('scwDataPointLimit', dataPointLimitPreference);
    //     }
    //   });
    // }
    // if (localStorage.getItem('scwDataPointLimit') !== null) {
    //   GeneralUtils.appendCookie('SCW_DATA_POINT_LIMIT', _.toString(localStorage.getItem('scwDataPointLimit')));
    // } else {
    //   GeneralUtils.appendCookie('SCW_DATA_POINT_LIMIT', _.toString(AppConstants.scwDataPointLimit));
    // }
  }

  componentDidUpdate() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  collapseSidebar() {
    const { sidebarOpen } = this.state;
    localStorage.setItem('isSidebarNavExpanded', (!sidebarOpen).toString());
    this.setState({ sidebarOpen: !sidebarOpen });
  }

  render() {
    const { sidebarOpen } = this.state;
    const { history } = this.props;
    // const cookies = document.cookie;

    const toastContainer = (
      <ToastContainer
        hideProgressBar
        className="mb40"
        position="bottom-right"
        newestOnTop
        containerId="toast-container-id"
      />
    );

    const clearAllToastsButton = (
      <Button
        style={{
          position: 'absolute',
          display: 'none',
          right: '28px',
          bottom: '20px',
          zIndex: 100,
        }}
        className="h40 w40 border-radius-all"
        variant="danger"
        type="button"
        id="close-all-toast-container"
        onClick={() => {
          toast.dismiss();
        }}
      >
        <FontAwesomeIcon
          icon={faArrowRight}
        />
      </Button>
    );

    const authToken = GeneralUtils.getCookieValue('AUTH_TOKEN');

    userDataUtil.registerPageView(history);

    if ((authToken && authToken.length > 1) || window.location.href.includes('wafer-image-generator')) {
      return (
        <>
          <ModalPopup />
          {toastContainer}
          <Container fluid>
            <Row>
              <Col
                className={
                  `${sidebarOpen === true ? 'sidebar-column ' : 'sidebar-column-collapse '} 
                  ${window.location.href.includes('wafer-image-generator') ? ' d-none' : ''}`
                }
              >
                <SidebarNav
                  collapseSidebar={this.collapseSidebar}
                  showMenuLabel={sidebarOpen}
                />
              </Col>
              <Col className="main-body-content main-body-content-width position-relative" id="main-dashboard">
                <Button
                  type="button"
                  variant="clear"
                  className="w30 h30 d-flex align-items-center justify-content-center background-color-light shadow border-radius-all"
                  onClick={this.collapseSidebar}
                  style={{
                    position: 'absolute',
                    left: '-14px',
                    top: '64px',
                    border: '1px solid black',
                  }}
                >
                  {
                    sidebarOpen
                      ? <FontAwesomeIcon size="sm" className="color-default-color" icon={faChevronLeft} />
                      : <FontAwesomeIcon size="sm" className="color-default-color" icon={faChevronRight} />
                  }
                </Button>
                <Switch>
                  {routes.getRoutes().map((item:any) => {
                    if (item.subRoutes) {
                      return item.subRoutes.map((subItem:any) => (
                        <Route exact key={`route_${subItem.path}`} path={subItem.path}>
                          {subItem.content}
                        </Route>
                      ));
                    }

                    return (
                      <Route exact key={`route_${item.path}`} path={item.path}>
                        {item.content}
                      </Route>
                    );
                  })}
                </Switch>
                {clearAllToastsButton}
              </Col>
            </Row>
          </Container>
        </>
      );
    }
    return (
      <>
        <Login />
        <ModalPopup />
        {toastContainer}
      </>
    );
  }
}

export default withRouter(Dashboard);
